module.exports = __webpack_public_path__ + "components/media-kit/static/skin-desktop-9ac7db021b14deee195dd5c0bc694ea6.png";